import * as React from 'react';
import { cn } from 'lib/utils';
import { Skeleton } from 'components/ui/skeleton';

import { PageHeaderWithCheckboxesContext } from './context';
import { Checkboxes } from './checkboxes';
import { FiltersToggleButton } from './filters-toggle-button';
import type { CheckboxesConfig } from './types';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  checkboxesConfig?: CheckboxesConfig;
  loadingConfig?: boolean;
};

export const PageHeaderWithCheckboxes = ({
                                           children,
                                           className,
                                           checkboxesConfig,
                                           loadingConfig,
                                           ...props
                                         }: Props) => {
  const [open, setOpen] = React.useState(false);
  const [selectedCheckboxValues, setSelectedCheckboxValues] = React.useState<string[]>([]);

  const resetSelectedCheckboxValues = React.useCallback(() => {
    setSelectedCheckboxValues(checkboxesConfig?.defaultSelected ?? []);
  }, [checkboxesConfig?.defaultSelected]);

  React.useEffect(() => {
    if (checkboxesConfig?.defaultSelected) {
      setSelectedCheckboxValues(checkboxesConfig?.defaultSelected);
    }
  }, [checkboxesConfig?.defaultSelected?.length]);

  return (
    <PageHeaderWithCheckboxesContext.Provider
      value={{
        open,
        setOpen,
        checkboxesConfig: checkboxesConfig ?? { options: [] },
        selectedCheckboxValues,
        setSelectedCheckboxValues,
        resetSelectedCheckboxValues,
      }}
    >
      <div
        {...props}
        className={cn(
          'flex flex-col w-full rounded-md bg-white px-6 py-4 shadow-sm shadow-slate-300',
          className,
        )}
      >
        <div className={'flex flex-row items-center'}>
          {loadingConfig
            ? <Checkboxes.Skeleton />
            : <Checkboxes />
          }
          <FiltersToggleButton className={'ml-auto'} />
        </div>
        <div
          className={cn(
            'border-t-slate-300 border-t pt-6 mt-4 hidden',
            open && 'flex',
          )}
        >
          {children}
        </div>
      </div>
    </PageHeaderWithCheckboxesContext.Provider>
  );
};

const CheckboxSkeleton = () => (
  <div className="flex flex-row items-center gap-2">
    <Skeleton className={'w-4 h-4'} />
    <Skeleton className={'w-20 h-4'} />
  </div>
);
